var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      ref: "popover",
      staticClass: "tooltip",
      attrs: {
        "auto-hide": true,
        placement: _vm.placement,
        trigger: "manual",
        "delay.show": "100",
        "delay.hide": "3000"
      }
    },
    [
      _c(
        "span",
        {
          on: {
            click: _vm.click,
            mouseleave: _vm.mouseLeave,
            mouseover: _vm.mouseOver
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("template", { slot: "popover" }, [
        _c(
          "span",
          {
            staticClass: "tooltip-inner",
            style: { color: _vm.color, background: _vm.background }
          },
          [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }